import React from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { SimulationAgentData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { DetailedAgentDepartureHypothesis } from '../helpers/types';
import AgentDepartureHypothesisChip from '../AgentDepartureHypothesisChip';

type Props = CellRendererParams<
    SimulationAgentData, // type of params.data
    DetailedAgentDepartureHypothesis // type of params.value
> & {
    recurrence: RecurrenceEnum;
    isUpdateEnabled: boolean;
    displayDate: boolean;
};

const AgentDepartureHypothesisCellRenderer = ({
    value,
    data,
    recurrence,
    isUpdateEnabled = true,
    displayDate = true,
}: Props): React.ReactElement =>
    data && value ? (
        <AgentDepartureHypothesisChip
            hypothesis={value}
            recurrence={recurrence}
            displayDate={displayDate}
            isUpdateEnabled={isUpdateEnabled}
        />
    ) : (
        <></>
    );
export default AgentDepartureHypothesisCellRenderer;
